import { Container, Grid } from '@mui/material';
import html2canvas from 'html2canvas';
import { t } from 'i18next';
import jsPDF from 'jspdf';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import OrderReport from 'src/components/pdfs/OrderReport';
import { showErrorTost } from 'src/constants';

const DownloadReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const chunkData = (data, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < data?.length; i += chunkSize) {
      chunks.push(data?.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const dataChunks = chunkData(data, 18);

  const downloadReport = async () => {
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');

      for (let i = 0; i < dataChunks.length; i++) {
        const input = document.getElementById(`page${i}`);
        const canvas = await html2canvas(input, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');

        if (i !== 0) pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, 0, 210, 297);
      }
      pdf.save('Order_Report.pdf');
      navigate(-1);
    } catch (error) {
      showErrorTost('Error Downloading Report');
    }
  };

  return (
    <Container sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      <Grid container mt={3} xs={4} sm={2}>
        <LoaderButton buttonText={t('common.download')} onClick={downloadReport} />
      </Grid>
      {dataChunks.map((chunk, index) => {
        return <OrderReport key={index} data={chunk} pageNumber={index} />;
      })}
    </Container>
  );
};

export default DownloadReport;
